import Factory from '../utils/factory'

export default Factory({
  id: null,
  name: null,
  isDefault: false,
  categories: [],
  ofType: 'Project',
  data: {
    theme: null,
  },
  customFields: null,
})
